import Tree from './Tree';
import TreeNode from './TreeNode';

Tree.TreeNode = TreeNode;

export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/~/rc-tree/es/index.js
// module id = 649
// module chunks = 3